var exports = {
  "kL": "ReportFlowSummary.module__container___a2hUem",
  "ed": "ReportFlowSummary.module__disclaimer___a2hUem",
  "uW": "ReportFlowSummary.module__section___a2hUem",
  "R_": "ReportFlowSummary.module__heading___a2hUem",
};

module.exports = exports;
